<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="slu-dashboard-courses"
            :items="tableData"
            :fields="courseFields">
            <template
                v-slot:options
                v-if="$authUser.hasRoleOrAdmin('slu')">
                <b-button
                    class="btn-add btn-add-slu-course"
                    v-b-modal="'add-slu-course-modal'"
                    type="button"
                    label="create-new-slu-course"
                    variant="primary">
                    {{ $t('slu_dashboard.manage_courses') }}
                </b-button>
            </template>

            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-open btn-open-slu-course"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('slu_dashboard.open')"
                        @click="openSluCourse(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-add-slu-course-modal-component
            :slu-courses-in="sluCourses"
            :courses-in="coursesIn"
            @updateCourses="updateCourses($event)"
            ref="add-slu-course-modal">
        </design-2021-add-slu-course-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-dashboard-courses-index-tab-component',
    props: ['sluCoursesIn', 'coursesIn'],
    data() {
        return {
            sluCourses: this.sluCoursesIn,
            courseFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        updateCourses(courses) {
            this.sluCourses = courses;
        },
        openSluCourse(sluCourseId) {
            window.location.href = this.routes.sluCourse(sluCourseId);
        },
    },
    computed: {
        tableData() {
            return this.sluCourses
                .map((course) => {
                    return {
                        id: course.id,
                        name: course.course.name,
                    };
                })
                .sort((a, b) => a.name.localeCompare(b.name));
        },
    },
};
</script>

<style scoped></style>
